export const MockStorageKey = {
  Scenario: 'mock_scenario',
  Delay: 'mock_delay',
  GroupApp: 'mock_group_app_enabled',
  Production: 'mock_production',
  ProviderRejects: 'mock_provider_rejects',
  Devbox: 'mock_devbox',
} as const;

export const MockScenario = {
  Forbidden: 'forbidden',
  SessionExpired: 'session_expired',
  Unresolved: 'unresolved',
  Citationless: 'citationless',
  SlowReply: 'slow_reply',
  EscalateError: 'escalate_error',
  PromptError: 'prompt_error',
} as const;

export const MOCK_FLAG_ON: Readonly<string> = '1';

export const MOCK_CONVERSATION_ID: Readonly<string> = 'abc123';

export const MOCK_REPLY_INTERACTION_ID: Readonly<string> = '2595202f-02ac-41ae-aa8e-2aa9f6311189';
